import type { SchemaBuilderFormListProps } from "./schema-builder-form-list.type";

import { PlusOutlined, QuestionCircleFilled } from "@ant-design/icons";
import { Button, Flex, Form, Tooltip, Typography } from "antd";
import classNames from "classnames";

import "./schema-builder-form-list.style.less";

export const SchemaBuilderFormList = ({
  name,
  title,
  tooltip,
  addText,
  className,
  renderField,
}: SchemaBuilderFormListProps) => {
  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <div
          className={classNames("schema-builder-form-list", className, {
            "-no-rows": !fields.length,
          })}
        >
          <Flex className="schema-builder-form-list-title">
            <Typography.Text>{title}</Typography.Text>
            <Tooltip placement="top" title={tooltip}>
              <QuestionCircleFilled />
            </Tooltip>
          </Flex>
          {fields.map((field, index) =>
            renderField?.(field, { index, fields, removeField: remove })
          )}
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={() => add()}
            aria-label={addText}
            className="schema-builder-form-list-add-button"
          >
            {addText}
          </Button>
        </div>
      )}
    </Form.List>
  );
};
